//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SectionMixin from '~/mixins/section'

export default {
  mixins: [
    SectionMixin
  ],
  methods: {
    trackQuizClicked () {
      this.addDDAction('Quiz clicked', { path: this.$route.path })
    }
  }
}
